module.exports = __webpack_public_path__ + "img/messenger.08bddc07.svg";